module.exports = __webpack_public_path__ + "static/img/legend_xg_spanish_dark_vertical.437d924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xg_spanish_dark_vertical.png
// module id = gOS5
// module chunks = 94